export enum TransactionFilter {
  Channel = 'channel',
  Currency = 'currency',
  Product = 'brand',
  TransactionType = 'displayTransactionType',
  TransactionState = 'displayTransactionState',
  Wallet = 'wallet',
  StoredCredentialType = 'storedCredentialType',
  Processor = 'sourcePIM',
  DestinationProcessor = 'destinationProcessor',  // For destination processor filtering
  AccountType = 'accountType',
  TokenType = 'instrumentType',
  Amount = 'amount',
  ReuseTokenContext = 'reuseTokenContext',
  Origin = 'sourceId',
  FundingSource = 'fundingSource',
  MerchantId = 'vfiMerchantId',
  Organisation = 'entityId',
  Organization = 'entityUid',
  ParentOrganisation = 'ancestorId',
  ProductFilter = 'product_filter',
  TransactionDate = 'transactionDate',
  SettledTime = 'settled_time',
  CutOffTime = 'cutoff_time',
  CashbackAmount = 'cashbackAmount',
  GratuityAmount = 'gratuityAmount',
  RSTransactionType = 'transactionType',
  RSTransactionState = 'headerState',
  FallbackMode = 'fallbackMode',
}
